import { Pipe, PipeTransform } from '@angular/core';
import { PaymentLocation } from 'src/generated_client/model/enumPaymentLocation';

@Pipe({
  name: 'paymentLocationLabel',
})
export class PaymentLocationLabelPipe implements PipeTransform {
  transform(value: PaymentLocation | null | undefined): string {
    switch (value) {
      case 1:
        return 'Origen';
      case 2:
        return 'Destino';
      case 3:
        return 'A cuenta';
      default:
        return '-';
    }
  }
}
